import React from 'react';
import { Upload, Database, RefreshCw } from 'lucide-react';

const DataSourceSelector = ({
  dataSource,
  setDataSource,
  file,
  fileName,
  sqlQuery,
  setSqlQuery,
  handleFileChange,
  handleUploadClick,
  handleAnalyze,
  isAnalyzing,
  error
}) => {
  return (
    <div className="mb-8">
      <div className="">
        <div className="flex space-x-4 mb-4">
          <button
            className={`p-2 rounded-md ${dataSource === 'file'
                ? 'bg-primary text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            onClick={() => setDataSource('file')}
          >
            <div className="flex items-center">
              <Upload className="w-3 h-3 mr-2" />
              <span className='text-sm'>CSV File</span>
            </div>
          </button>
          <button
            className={`p-2 rounded-md ${dataSource === 'sql'
                ? 'bg-primary text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            onClick={() => setDataSource('sql')}
          >
            <div className="flex items-center">
              <Database className="w-3 h-3 mr-2" />
              <span className='text-sm'>SQL Query</span>
            </div>
          </button>
        </div>

        {dataSource === 'file' ? (
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
            <input
              id="file-upload"
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              className="hidden"
            />
            {!file ? (
              <div>
                <Upload className="mx-auto h-6 w-6 text-gray-400" />
                <p className="mt-2 text-sm text-gray-600">
                  Click to upload or drag and drop
                </p>
                <button
                  onClick={handleUploadClick}
                  className="mt-2 px-4 py-2 bg-gray-100 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-200"
                >
                  Choose Dataset (CSV)
                </button>
              </div>
            ) : (
              <div>
                <p className="text-sm font-medium text-gray-900">{fileName}</p>
                <button
                  onClick={handleUploadClick}
                  className="mt-2 text-sm text-primary hover:text-primary-dark"
                >
                  Change file
                </button>
              </div>
            )}
          </div>
        ) : (

          <textarea
            id="sql-query"
            rows={5}
            className="w-full border rounded-md p-2 text-sm font-mono"
            placeholder="SELECT * FROM your_table WHERE condition"
            value={sqlQuery}
            onChange={(e) => setSqlQuery(e.target.value)}
          />
        )}

        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}

        <div className="mt-4 flex justify-end">
          <button
            onClick={handleAnalyze}
            disabled={isAnalyzing}
            className="px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondaryDark disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {isAnalyzing ? (
              <div className="flex items-center">
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                <span>Processing...</span>
              </div>
            ) : (
              'Launch Advanced Analysis'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataSourceSelector;